import React, { useState,useEffect } from 'react'
import portalServices from '../../../portalServices'
import AppHeader from '../../../components/AppHeader'
import OTPLoginPage from '../../../components/OTPLoginPage';
import moment from 'moment';
import AppFooter from '../../../components/AppFooter';
import { Link } from 'react-router-dom';
import { Today } from '@mui/icons-material';


const FollowUpDetails = ({details}) =>{
    return (
        <div className='card mb-2'>
            <div className='card-header'> <span className='fw-bold'>{details.customerName}</span> <sapn className="float-end">{moment(details.nextVisitDate).format("LL")}</sapn> </div>
            <div className='card-body'>
                With {details.firstName} {details.lastName}
                <Link className='btn btn-outline-primary ms-2' to={"/checkin/queue"}><Today/> Book Appointment</Link>
            </div>
        </div>
    )
}


function FollowUpListPage() {

    const [customerToken,setCustomerToken] =  useState(localStorage.customerToken);
    const [followUpList,setFollowUpList] = useState([])

    const getFollowUpList = () =>{
        if(customerToken){
            let payload = {
                customerToken : customerToken
            }
            portalServices.getFollowUpList(payload).then(res=>{
                setFollowUpList(res.data);
            }).catch(error=>{
            }).finally(()=>{
            })
        }
    }

    useEffect(()=>{
        getFollowUpList();
    },[customerToken])

    return (
        <>
            <AppHeader/>
            <div className='container'>
                {
                    (customerToken === null || customerToken === undefined)?
                        <OTPLoginPage
                        setCustomerToken={setCustomerToken}
                        /> 
                    :
                    <div className='row mt-4'>
                        {followUpList.length > 0 ?
                            <div className='col-md-12'>
                                {followUpList && followUpList.map(followUp=>
                                    <FollowUpDetails details={followUp} />
                                )}
                            </div>
                            :
                            <div className='col-md-12'>
                                <h3 className="text-center">No Record Found</h3>
                            </div>
                        }
                    </div>
                }
            </div>
            <AppFooter/>
        </>
    )
}

export default FollowUpListPage